var exports = {
  "k": "xfd349460--4833cc--container",
  "n": "xfd349460--4833cc--link",
};

module.exports = exports;
